<template>
  <div class="text-field">
    <label
      v-if="!hideLabel && label"
      :class="{ 'required-flag': required }"
    >
      {{ label }}{{ showColon ? ':' : '' }}
    </label>
    <pre v-if="!readonlyAsInput && readonly && (value || defaultEmpty)"><p>{{ value || '--' }}</p></pre>
    <div
      v-if="readonlyAsInput || !readonly"
      class="row text-input"
    >
      <p
        v-if="hintBeforeInput"
        :class="hintClass"
      >
        {{ hintBeforeInput }}
      </p>
      <textarea
        v-autosize
        v-hkldinput="{ component: parentNode, unchecked: !dirtyCheck }"
        v-fusioninputcheck="{type: 'string', tip: inputTip, required}"
        :class="[{ 'small-2 medium-2 large-2 columns': text}, extendClass ]"
        class="autosize"
        :value="value"
        :disabled="readonlyAsInput"
        :placeholder="placeholder"
        :required="required"
        @change="event => $emit('updateValue', event.target.value)"
        @input="onInput"
        @focusout="afterBlur"
      />
      <pre><p
        v-if="text"
        class="additional-text"
      >{{ text }}</p></pre>
    </div>
  </div>
</template>

<script>
import i18n from '@/utils/i18n'
export default {
  name: 'TextField',
  model: {
    prop: 'value',
    event: 'updateValue',
  },
  props: {
    label: String,
    value: String,
    text: String,
    hideLabel: Boolean,
    required: Boolean,
    readonly: Boolean,
    readonlyAsInput: {
      type: Boolean,
      default: false,
    },
    showColon: {
      type: Boolean,
      default: true,
    },
    hintBeforeInput: String,
    hintClass: String,
    placeholder: String,
    parentNode: String,
    inputTip: {
      type: String,
      default: () => i18n.t('hint.inputTip.string'),
    },
    afterBlur: {
      type: Function,
      default: () => {},
    },
    extendClass: {
      type: String,
      default: '',
    },
    dirtyCheck: {
      type: Boolean,
      default: true,
    },
    defaultEmpty: Boolean,
  },
  methods: {
    onInput (e) {
      let val = e.target.value
      if (!this.readonlyAsInput) {
        this.$emit('inputValue', val)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/textField';
</style>
